module.exports = ".gallery-image {\n  padding: 5%; }\n  .gallery-image img {\n    height: 240px;\n    width: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-gallery/home-gallery.component.scss
// module id = ./src/app/components/home/home-gallery/home-gallery.component.scss
// module chunks = main